/*
 * Copyright (c) Castle Point Learning Systems Corporation, 2013-2023, all rights reserved.
 * NOTICE: Dissemination of the information and/or materials contained in this file is strictly
 * forbidden unless prior written permission is obtained from Castle Point Learning Systems Corporation.
 * See LICENSE.txt (part of this package) for the full notice.
 */

import React, { useMemo } from 'react';
import { Styled as S } from '../../VerticalSolver.styled';
import { createAPI, Latex as Katex } from 'semantic-math-editor';
import { fromGRL } from '../../../types/grl/GRL';

interface GrlProps {
    children: string;
}

export const Grl: React.FC<GrlProps> = React.memo(({ children }) => {
    const html = useMemo<string>(() => {
        try {
            const api = createAPI();
            api.setTree(fromGRL(children));
            return Katex.renderLatex(api.getLatex());
        } catch (e) {
            return e.message;
        }
    }, [children]);

    return html && <S.Ltx dangerouslySetInnerHTML={{ __html: html }} />;
});
